<template>
  <div class="card card-custom gutter-b border-0 shadow-sm">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column mb-0">
        <span class="card-label font-weight-bolder text-dark">Kredensial Web Service</span>
        <span class="text-muted mt-2 font-weight-bold font-size-sm">Silahkan masukkan Client ID, Secret Key, dan Organization ID.</span>
      </h3>
    </div>
    <div class="card-body pt-0 pb-6">
      <div class="custom-alert custom-alert-warning mb-8">
        <div class="custom-alert-badge">
          <i class="fas fa-exclamation-triangle" style="font-size: 10px;"></i> Warning
        </div>
        <div class="custom-alert-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <div class="d-flex flex-column">
          <span class="font-weight-bolder text-dark mb-1" style="font-size: 15px;">Kredensial Sensitif</span>
          <span class="text-dark-75 font-weight-bold" style="font-size: 13px;">Gunakan kredensial resmi milik fasilitas kesehatan. Jangan membagikannya kepada pihak lain.</span>
        </div>
      </div>

      <b-form @submit.stop.prevent="formOnsubmit">
        <!-- client_id -->
        <b-form-group
          label="Client ID:"
          label-for="input-client_id"
          label-class="font-weight-bolder"
        >
          <b-form-input
            id="input-client_id"
            v-model="form.client_id"
            type="text"
            class="form-control-solid form-control-lg"
            placeholder="Masukkan Client ID"
          >
          </b-form-input>
          <small class="text-danger" v-if="error.client_id">{{ error.client_id }}</small>
        </b-form-group>

        <!-- secret client -->
        <b-form-group
          label="Secret Key:"
          label-for="input-secret_key"
          label-class="font-weight-bolder"
        >
          <b-form-input
            id="input-secret_key"
            v-model="form.client_secret"
            type="password"
            class="form-control-solid form-control-lg"
            placeholder="Masukkan Secret Key"
          >
          </b-form-input>
          <small class="text-danger" v-if="error.client_secret">{{ error.client_secret }}</small>
        </b-form-group>

        <!-- Input Quantity -->
        <b-form-group
          label="Organization ID:"
          label-for="input-organization_id"
          label-class="font-weight-bolder"
        >
          <b-form-input
            id="input-organization_id"
            v-model="form.organization_id"
            class="form-control-solid form-control-lg"
            placeholder="Masukkan Organization ID"
          >
          </b-form-input>
          <small class="text-danger" v-if="error.organization_id">{{ error.organization_id }}</small>
        </b-form-group>

        <div class="d-flex mt-8">
          <b-button type="submit" variant="primary" class="font-weight-bold px-8">
            <i class="fas fa-save mr-2"></i>Simpan
          </b-button>
          <b-button
            type="button"
            variant="light-success"
            class="ml-3 font-weight-bold px-6"
            @click="testConnection()"
          >
            <i class="fas fa-plug mr-2"></i>Test Koneksi
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  setTokenBridge,
  setTokenSatuSehat,
  setRefreshTokenBridge,
  setSsOrganizationId,
  setSsLocationDefault,
  getConfiguration,
} from "@/core/services/jwt.service.js";
import {
  UPDATE_SS_CLIENT_ID,
  UPDATE_SS_CLIENT_SECRET,
  UPDATE_SS_ORGANIZATION_ID,
  UPDATE_SS_ACCESS_TOKEN,
} from "@/core/services/store/tokenstore.module";

import ApiService from "@/core/services/api.service.js";
import JwtService from "@/core/services/jwt.service";

export default {
  props: {
    form: Object,
    route: String,
  },

  data() {
    return {
      error: {
        client_id: null,
        client_secret: null,
        organization_id: null,
      },
    };
  },

  methods: {
    testConnection() {
      SwalLoading.fire();
      let login_data_api_bridge = {
        username: "medhop@wellmagic.id",
        password: "wm547u53h47",
        grant_type: "password",
        scope: "*",
        ss_client_id: this.form.client_id,
        ss_client_secret: this.form.client_secret,
        satu_sehat_clinic_id:
          JwtService.getConfiguration().satu_sehat_clinic_id,
      };

      ApiService.bridge
        .post("oauth/token", login_data_api_bridge)
        .then((response) => {
          let data = response.data;
          setTokenBridge(data.bridge.access_token);
          setRefreshTokenBridge(data.bridge.refresh_token);
          setTokenSatuSehat(data.satusehat.access_token);
          setSsOrganizationId(this.form.organization_id);
          setSsLocationDefault(this.form.location_default);
          this.$store.dispatch(
            UPDATE_SS_ACCESS_TOKEN,
            data.satusehat.access_token
          );
          ApiService.setHeaderBridge(data.bridge.access_token);
          SwalLoading.close();

          Swal.fire({
            title: "Berhasil",
            text: "Berhasil koneksi ke satu sehat",
            icon: "success",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((err) => {
          SwalLoading.close();
          Swal.fire({
            title: "Gagal",
            text: "Gagal koneksi ke satu sehat. Periksa kembali Client ID atau Secret Key",
            icon: "error",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        });
    },
    async formOnsubmit() {
      // Make Request
      let response = await module.submit(this.form, this.route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        let login_data_api_bridge = {
          username: "medhop@wellmagic.id",
          password: "wm547u53h47",
          grant_type: "password",
          scope: "*",
          ss_client_id: this.form.client_id,
          ss_client_secret: this.form.client_secret,
          satu_sehat_clinic_id:
                JwtService.getConfiguration().satu_sehat_clinic_id,
        };

        ApiService.bridge
          .post("oauth/token", login_data_api_bridge)
          .then((response) => {
            let data = response.data;
            setTokenBridge(data.bridge.access_token);
            setRefreshTokenBridge(data.bridge.refresh_token);
            setTokenSatuSehat(data.satusehat.access_token);
            setSsOrganizationId(this.form.organization_id);
            setSsLocationDefault(this.form.location_default);
            this.$store.dispatch(
              UPDATE_SS_ACCESS_TOKEN,
              data.satusehat.access_token
            );
            ApiService.setHeaderBridge(data.bridge.access_token);
          });

        let form = {
          client_id: this.form.client_id,
          client_secret: this.form.client_secret,
          organization_id: this.form.organization_id,
          satu_sehat_clinic_id: getConfiguration().satu_sehat_clinic_id,
        };
        ApiService.bridge.post("access-ss-update", form).then((response) => {
          window.location.reload();
        });
      }
    },
  },

  mounted() {},
};
</script>

<style>
</style>